




































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { UnidadeProdutoRelatorioFiltrosDTO } from '@/interfaces/client-units-products-report';
import * as service from '@/services/client-units-products-report';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    UiSelectClients,
    UiDatePickerRange,
    UiSelectDoctor
  }
})
export default class ClientUnitsProductsReport extends BaseComponent {
  filter: any = {};

  productsLoading = false;
  products = [];

  codesLoading = false;
  codes = [];

  error = false;
  loading = false;
  loadingXls = false;
  executed = false;

  items = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO();

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {
    }
  };

  headers = [
    { text: 'Unidade', value: 'unidade', sortable: true },
    { text: 'Cliente', value: 'cliente', sortable: true },
    { text: 'Código do Produto', value: 'codProduto', sortable: true },
    { text: 'Nome do Produto', value: 'nomeProduto', sortable: true }
  ];

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.loadProducts();
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listDataClientUnitsProdutsReport(filter);
        })
      )
      .subscribe(
        (res) => {
          this.items = res;
          this.loading = false;
          this.pagination.page = 1;
          this.executed = true;
        },
        (error) => {
          this.loading = false;
          this.error = true;
        }
      );
  }

  loadProducts() {
    this.productsLoading = true;
    service.listProductsClientUnitsProdutsReport().subscribe(
      (res) => {
        this.products = res;
        this.productsLoading = false;
      },
      (error) => {
        this.showToastApiError(error);
        this.productsLoading = false;
      }
    );
  }

  public exec() {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    this.executed = false;
    this.loading = true;
    this.error = false;

    let parm = this.buildFilterParm();
    this.execBehaviorSub$.next(parm);
  }

  private buildFilterParm() {
    let parm = new UnidadeProdutoRelatorioFiltrosDTO();
    let filter = this.filter;

    parm.idsProdutos = filter.idsProdutos;
    parm.idsUnidades = filter.clientUnits ? filter.clientUnits.map((u) => u.id) : [];

    return parm;
  }

  public exportXls() {
    this.loader.start('Gerando XLS...');
    this.loadingXls = true;
    let parm = this.buildFilterParm();

    service.buildClientUnitsProdutsXlsReport(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.loadingXls = false;
        this.forceFileAxiosResponseDownload(res, 'relatorio.xls');
      },
      (error) => {
        this.loader.stop();
        this.loadingXls = false;
        this.showToastApiError(error);
      }
    );
  }
}
